<template>
    <div class="footer">
        <img
            v-show="correct === true"
            :src="
                require(`@/assets/Stage/Game/${type}/level${level}/yes${shuffle()}.png`)
            "
            alt=""
            width="100%"
        />
        <img
            v-show="correct === false"
            :src="
                require(`@/assets/Stage/Game/${type}/level${level}/no${shuffle()}.png`)
            "
            alt=""
            width="100%"
        />
        <div v-show="correct !== true && correct !== false">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        type: String,
        level: String,
        correct: Boolean,
    },
    methods: {
        shuffle() {
            const RANDOM = (Math.floor(Math.random() * 2) % 2) + 1;
            return RANDOM;
        },
    },
};
</script>

<style lang="scss" scoped>
.footer img {
    display: block;
}
</style>
